export default () => ({
  settings: null,
  countries: [],
  products: [],
  categories: [],
  closedModalActive: false,
  order: {},
});
